// Force-pair the sibling-swatch element + the quick-add element of every
// product card into a single .card-gallery__row child of that card's
// .card-gallery. Runs as a global script loaded from theme.liquid so it
// survives async section injection (product-recommendations, predictive
// search, infinite scroll, AJAX swaps).
//
// Robustness changes (Jun 17): re-check on EVERY relevant DOM event,
// don't trust `data-moved` for skipping — instead check the actual DOM
// position (parentNode === row). This way if parent quick-add.js reflows
// or re-injects either element, we immediately re-pair them.
(function () {
  if (window.__ashCardRowMoverInit) return;
  window.__ashCardRowMoverInit = true;

  function ensureRow(gallery) {
    var row = gallery.querySelector(':scope > .card-gallery__row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'card-gallery__row';
      gallery.appendChild(row);
    }
    // Row must be the LAST child so the absolutely positioned hover
    // overlay below the image isn't covering it.
    if (row.nextElementSibling) {
      gallery.appendChild(row);
    }
    return row;
  }

  function nearestCardOf(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.nodeType === 1) {
        var t = node.tagName ? node.tagName.toLowerCase() : '';
        if (t === 'product-card') return node;
        if (
          node.classList &&
          (node.classList.contains('product-card') ||
            /(^|\s)product-card(\s|$|--|__)/.test(node.className || ''))
        )
          return node;
        if (node.dataset && node.dataset.productCard != null) return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function pair(gallery) {
    var card = nearestCardOf(gallery);
    if (!card) return false;

    // Look both INSIDE and adjacent to the card.
    var sw = card.querySelector('.ash-auto-cs');
    var qa = card.querySelector('quick-add-component');

    // If either is missing inside this product-card, also fall back to
    // the gallery's own descendant tree (in case the gallery itself is
    // a standalone block with no .product-card wrapper).
    if (!sw) sw = gallery.parentElement && gallery.parentElement.querySelector('.ash-auto-cs');
    if (!qa) qa = gallery.querySelector('quick-add-component');

    if (!sw && !qa) return false;

    var row = ensureRow(gallery);
    var moved = false;
    if (sw && sw.parentNode !== row) {
      row.appendChild(sw);
      sw.setAttribute('data-in-row', '1');
      moved = true;
    }
    if (qa && qa.parentNode !== row) {
      row.appendChild(qa);
      qa.setAttribute('data-in-row', '1');
      moved = true;
    }
    return moved;
  }

  function moveAll(root) {
    (root || document).querySelectorAll('.card-gallery').forEach(pair);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      moveAll(document);
    });
  }

  function start() {
    moveAll(document);

    // Broad mutation observer — re-pair on ANY mutation that touches
    // a card-relevant node. Cheap: we just re-walk .card-gallery and
    // each gallery's pair() is a no-op when already correctly placed.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var addedRelevant = false;
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (!n || n.nodeType !== 1) continue;
            if (
              n.matches &&
              n.matches('.card-gallery, .ash-auto-cs, quick-add-component, .quick-add, product-card, .product-card')
            ) {
              addedRelevant = true;
              break;
            }
            if (
              n.querySelector &&
              n.querySelector('.card-gallery, .ash-auto-cs, quick-add-component')
            ) {
              addedRelevant = true;
              break;
            }
          }
        }
        if (addedRelevant) { schedule(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    // Short early settle only (async card HTML). MO + section:load
    // cover the rest — keep the burst short to free main-thread.
    var fast = 0;
    var fastPoll = setInterval(function () {
      moveAll(document);
      if (++fast > 8) clearInterval(fastPoll);
    }, 400);

    document.addEventListener('shopify:section:load', function (e) {
      moveAll(e.target);
      requestAnimationFrame(function () { moveAll(e.target); });
    });

    // Re-pair on every hover/focus of a card — guarantees correct
    // pairing the moment the row becomes visible.
    document.addEventListener('pointerenter', function (e) {
      var g = e.target && e.target.closest && e.target.closest('.card-gallery');
      if (g) pair(g);
    }, true);
    document.addEventListener('focusin', function (e) {
      var g = e.target && e.target.closest && e.target.closest('.card-gallery');
      if (g) pair(g);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
